
import offers from "@/apollo/queries/offer/offers";
import { mapGetters } from "vuex";

export default {
	props: {
		pageTitle: String
	},
	data() {
		return {
			loading: true,
			liked_offers: []
		}
	},
	computed: {
		...mapGetters({
			site_id: 'site_id'
		}),
		component() {
			return 'catalog-item-minicard'
		}
	},
	async mounted() {
		if (process.client) {
			if (localStorage.getItem('likes')) {
				this.loading = true
				let external_id_array = localStorage.getItem('likes').split(',').map(i => Number(i))
				let client = this.$apolloProvider.defaultClient
				try {
					let response = await client.query(
						{
							query: offers,
							variables: {
								site_id: this.site_id,
								limit: 0,
								page: 1,
								external_id_array
							},
							fetchPolicy: 'network-only'
						})
					this.liked_offers = response.data.offers.data
					this.loading = false
				} catch (e) {
					// this.$nuxt.error({statusCode: 404})
				}
			} else {
				this.loading = false
			}
		}
	}
}
